<template>
  <div>
    <div class="item card-section">
      <div class="card-section-container">
        <div class="card-section-item">
          <h4 class="text-white"><b>REPORTS</b></h4>
        </div>
        <div class="card-section-item text-right">
          <button class="btn btn-outline-light" disabled>View Reports</button>
        </div>
      </div>
      <div class="card-section-container">
        <div class="card-section-item text-center">
          <h4 class="text-white"><loading-placeholder width="60px" /></h4>
          <p class="text-muted">Amount Received</p>
        </div>
        <div class="card-section-item text-center">
          <h4 class="text-white"><loading-placeholder width="60px" /></h4>
          <p class="text-muted">Amount Pending</p>
        </div>
      </div>
    </div>
    <div class="item card-section">
      <div class="card-section-container">
        <div class="card-section-item">
          <h4 class="text-white"><b>ACTIVITY</b></h4>
        </div>
        <div class="card-section-item text-right">
          <button class="btn btn-outline-light" disabled>View Activity</button>
        </div>
      </div>
      <div class="card-section-container">
        <div class="card-section-item text-center">
          <h2 class="text-white"><loading-placeholder width="40px" /></h2>
          <p class="text-muted">Open Tasks</p>
        </div>
        <div class="card-section-item text-center">
          <h2 class="text-white"><loading-placeholder width="40px" /></h2>
          <p class="text-muted">Quotes to Review</p>
        </div>
        <div class="card-section-item text-center">
          <h2 class="text-white"><loading-placeholder width="40px" /></h2>
          <p class="text-muted">Stuff to Ship</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingPlaceholder from './shared/loading-placeholder'
export default {
  name: 'overview-loading',
  components: { LoadingPlaceholder }
}
</script>
